import { render, staticRenderFns } from "./DefaultRestrictionsForm.vue?vue&type=template&id=595d39e9&scoped=true&"
import script from "./DefaultRestrictionsForm.vue?vue&type=script&lang=js&"
export * from "./DefaultRestrictionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d39e9",
  null
  
)

export default component.exports